/**
 * Canonical backend order status symbolic constants.
 *
 * Use these instead of string literals to avoid magic values (Fowler: Replace
 * Magic Literal with Symbolic Constant). Example:
 *
 *     if (order.status === ORDER_STATUS.CONFIRMED) { ... }
 */
export const ORDER_STATUS = {
    PENDING_PAYMENT: 'PENDING_PAYMENT',
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    PREPARING: 'PREPARING',
    READY: 'READY',
    IN_TRANSIT: 'IN_TRANSIT',
    DELIVERED: 'DELIVERED',
    CANCELLED: 'CANCELLED',
    SCHEDULED: 'SCHEDULED',
};
export const ORDER_STATUS_SEQUENCE = [
    'pending',
    'confirmed',
    'preparing',
    'ready',
    'in-transit',
    'delivered',
    'cancelled',
    'scheduled'
];
/**
 * Status-to-Badge mapping
 *
 * Semantic mapping:
 * - pending → warning (requires attention)
 * - confirmed → purple (assigned to florist)
 * - preparing → warning (yellow/orange)
 * - ready → success (green)
 * - in-transit → info (blue)
 * - delivered → success (green)
 * - cancelled → danger (red)
 * - scheduled → neutral (gray)
 */
export const ORDER_STATUS_METADATA = {
    'pending-payment': {
        label: 'Ожидает оплаты',
        description: 'Заказ создан, ожидается подтверждение платежа',
        badgeVariant: 'warning',
    },
    pending: {
        label: 'Ожидает подтверждения',
        description: 'Заказ принят и обрабатывается',
        badgeVariant: 'warning', // Changed from 'info' - requires operator attention
    },
    confirmed: {
        label: 'Подтвержден',
        description: 'Заказ подтвержден и передан флористу',
        badgeVariant: 'purple',
    },
    preparing: {
        label: 'Подготавливается',
        description: 'Флорист готовит букет',
        badgeVariant: 'warning',
    },
    ready: {
        label: 'Готов к доставке',
        description: 'Букет готов и ожидает доставки',
        badgeVariant: 'success',
    },
    'in-transit': {
        label: 'В пути',
        description: 'Заказ в пути к получателю',
        badgeVariant: 'info',
    },
    delivered: {
        label: 'Доставлен',
        description: 'Заказ доставлен получателю',
        badgeVariant: 'success',
    },
    cancelled: {
        label: 'Отменен',
        description: 'Заказ отменен',
        badgeVariant: 'danger',
    },
    scheduled: {
        label: 'Запланирован',
        description: 'Доставка запланирована на будущее',
        badgeVariant: 'neutral',
    }
};
export function getOrderStatusLabel(status) {
    return ORDER_STATUS_METADATA[status]?.label ?? status;
}
export function getOrderStatusDescription(status) {
    return ORDER_STATUS_METADATA[status]?.description ?? status;
}
export const COURIER_STATUS_METADATA = {
    COURIER_ASSIGNED: {
        label: 'Назначен курьер',
        description: 'Курьер назначен на заказ',
        badgeVariant: 'info',
        color: '#10B981' // Green
    },
    COURIER_ACCEPTED: {
        label: 'Курьер принял',
        description: 'Курьер принял заказ',
        badgeVariant: 'purple',
        color: '#3B82F6' // Blue
    },
    PICKED_UP: {
        label: 'Забран',
        description: 'Курьер забрал заказ',
        badgeVariant: 'purple',
        color: '#8B5CF6' // Purple
    },
    IN_TRANSIT: {
        label: 'В пути',
        description: 'Курьер везет заказ',
        badgeVariant: 'info',
        color: '#8B5CF6' // Purple
    },
    COURIER_ARRIVED: {
        label: 'Прибыл',
        description: 'Курьер прибыл к месту доставки',
        badgeVariant: 'warning',
        color: '#F59E0B' // Amber
    },
    DELIVERED: {
        label: 'Доставлен',
        description: 'Заказ доставлен получателю',
        badgeVariant: 'success',
        color: '#6B7280' // Gray
    },
    COMPLETED: {
        label: 'Выполнен',
        description: 'Заказ полностью завершен',
        badgeVariant: 'success',
        color: '#6B7280' // Gray
    }
};
export function getCourierStatusLabel(status) {
    return COURIER_STATUS_METADATA[status]?.label ?? status;
}
export function getCourierStatusColor(status) {
    return COURIER_STATUS_METADATA[status]?.color ?? '#9CA3AF';
}
